import { render, staticRenderFns } from "./RequestAccreditationEventInfo.view.vue?vue&type=template&id=0087777c&scoped=true"
import script from "./RequestAccreditationEventInfo.view.vue?vue&type=script&lang=js"
export * from "./RequestAccreditationEventInfo.view.vue?vue&type=script&lang=js"
import style0 from "./RequestAccreditationEventInfo.view.vue?vue&type=style&index=0&id=0087777c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087777c",
  null
  
)

export default component.exports